import EventModule from './EventModule';

export class EventServerModule extends EventModule {}

export default EventServerModule;
